import styled from 'styled-components';
import { isBrandAC, isBrandAP, isBrandDS, isBrandOV, isMarketGB } from '../../constants/main';
import { ButtonStyles, IButtonStyles } from '../Button/ButtonStyled';
import { StylesAC } from './Styles.AC';
import { StylesAP } from './Styles.AP';
import { StylesDS } from './Styles.DS';
import { StylesOV } from './Styles.OV';
import { StylesOVGB } from './Styles.OVGB';

const ButtonLink = styled.a<IButtonStyles>`
    ${ButtonStyles}

    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 100%;
    text-decoration: none;

    ${isBrandAC && StylesAC};
    ${isBrandAP && StylesAP};
    ${isBrandDS && StylesDS};
    ${isBrandOV && (isMarketGB ? StylesOVGB : StylesOV)}
`;

export default ButtonLink;
